

export class AppLogUtils {

    static error(msg:string,obj?:any){
        console.log(msg,obj??'');
    }
    
    static info(msg:string,obj?:any){
        console.log(msg,obj??'');
    }
    
    static debug(msg:string,obj?:any){
        console.log(msg,obj??'');
    }
    
    static warn(msg:string,obj?:any){
        console.log(msg,obj??'');
    }
    
    static trace(msg:string,obj?:any){
        console.log(msg,obj??'');
    }
}